<template>
  <div class="timer">

    <h1>{{ exerciseNum }} / {{ exercises}}</h1>
    <h2>{{ time2Str(timeLeft) }}</h2>
    <TimerRings :inner-val="innerVal" :outer-val="outerVal" :is-work="isWork">
      {{ time2Str(itemLeft) }}
    </TimerRings>
    <div class="buttons">
      <button @click="close">X</button>
      <button v-if="!isRunning" @click="resumeWorkout">play</button>
      <button v-if="isRunning" @click="pauseWorkout">pause</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import TimerRings from '@/components/TimerRings.vue'
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import NoSleep from 'nosleep.js'
import { useTimer } from '@/composables/useTimer'
import { useSound } from '@/composables/useSound'
import { useBackground, BackgroundThemes } from '@/composables/useBackground'

const router = useRouter()
const { backgroundTheme } = useBackground()
const { totalTimeMs, exercises, workMs, restMs, time2Str, rest } = useTimer()
const { tickShort, tickLong, tickFinal } = useSound()

const noSleep = new NoSleep()
const isRunning = ref(false)
const innerVal = ref(0)
const outerVal = ref(0)

const interval = ref(0)
const startTs = ref(0)
const millesMem = ref(0)

const exerciseNum = ref(0)
const isWork = ref(false)

const timeLeft = ref(0)
const itemLeft = ref(rest.value)

let lastSound = 0
let wasWork = false

onMounted(() => {
  backgroundTheme.value = BackgroundThemes.START
})

function close () {
  millesMem.value = 0
  pauseWorkout()
  router.back()
}

function resumeWorkout () {
  noSleep.enable()
  startTs.value = Date.now()
  interval.value = setInterval(fire, 10)
  isRunning.value = true
  // navigator.wakeLock.request('screen')
}

function pauseWorkout () {
  noSleep.disable()
  millesMem.value = millesMem.value + Date.now() - startTs.value
  isRunning.value = false

  clearInterval(interval.value)
}

function setBgColor () {
  let newBg = BackgroundThemes.START
  if (isRunning.value) {
    newBg = isWork.value ? BackgroundThemes.WORK : BackgroundThemes.REST
  }
  if (backgroundTheme.value !== newBg) backgroundTheme.value = newBg
}

function fire () {
  const exerciseLen = workMs.value + restMs.value
  const millisPassed = Date.now() - startTs.value + millesMem.value
  exerciseNum.value = Math.ceil(millisPassed / exerciseLen)
  const currExerciseMs = millisPassed % exerciseLen
  isWork.value = (currExerciseMs > restMs.value)

  let innerPerc = isWork.value
    ? (currExerciseMs - restMs.value) / workMs.value
    : currExerciseMs / restMs.value

  timeLeft.value = (totalTimeMs.value - millisPassed) / 1000
  itemLeft.value = isWork.value
    ? Math.ceil((workMs.value - currExerciseMs + restMs.value) / 1000)
    : Math.ceil((restMs.value - currExerciseMs) / 1000)

  if (millisPassed >= totalTimeMs.value) {
    clearInterval(interval.value)
    exerciseNum.value = exercises.value
    innerPerc = 1
    backgroundTheme.value = BackgroundThemes.FINAL
    tickFinal.play()
    return
  }

  for (const i of [1, 2, 3]) {
    if (itemLeft.value === i && lastSound !== i) {
      lastSound = i
      tickShort.play()
    }
  }

  if (isWork.value !== wasWork && innerPerc !== 1) {
    wasWork = isWork.value
    tickLong.play()
  }

  innerVal.value = innerPerc
  outerVal.value = millisPassed / totalTimeMs.value
  setBgColor()
}

</script>

<style scoped lang="scss">
  .timer {

    .buttons {
      button {
        margin: 1rem;
      }
    }
  }
</style>
